import React, {useEffect, useState} from "react";
import {setSimulateurObject} from "../../../actions/simulateur.action";
import {useDispatch} from 'react-redux';
import {styles} from "../../../stylesheets/simulateurs.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";

//bail d'habitation
//id simu 29

function Simulateur_A1_29(props, simulateur, isParent, departements) {

    let currUser = JSON.parse(localStorage.getItem("user"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")){
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

    const dispatch = useDispatch();
    const [departement, setDepartement] = useState(0)
    const [montant_loyer_mensuel, setMontant] = useState(0)
    const [diagnostic, setDiagnostic] = useState(0)
    const [page, setPage] = useState(0)

    const handleChange = async (setter, value) => {
        if (setter === setDepartement) {
            setDepartement(parseInt(value))
        } else setter(value);
        setInRedux(setter, value)
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

    function setInRedux(setter, value) {
        if (props.isParent) {

            let object = {
                "simulateurid": props.simulateur.id,
                "departementid": 0,
                "inputs": {}
            };

            if (setter === setDepartement) {
                Object.assign(object['inputs'], {'montant_loyer_mensuel': parseInt(montant_loyer_mensuel)})
                Object.assign(object['inputs'], {'nombre_diagnostic': parseInt(diagnostic)})
                Object.assign(object['inputs'], {'nombre_page_copie': parseInt(page)})
                object.departementid = parseInt(value)
            }

            if (setter === setMontant) {
                Object.assign(object['inputs'], {'montant_loyer_mensuel': parseInt(value)})
                Object.assign(object['inputs'], {'nombre_diagnostic': parseInt(diagnostic)})
                Object.assign(object['inputs'], {'nombre_page_copie': parseInt(page)})
                object.departementid = parseInt(departement)
            }

            if (setter === setDiagnostic) {
                Object.assign(object['inputs'], {'montant_loyer_mensuel': parseInt(montant_loyer_mensuel)})
                Object.assign(object['inputs'], {'nombre_diagnostic': parseInt(value)})
                Object.assign(object['inputs'], {'nombre_page_copie': parseInt(page)})
                object.departementid = parseInt(departement)
            }

            if (setter === setPage) {
                Object.assign(object['inputs'], {'montant_loyer_mensuel': parseInt(montant_loyer_mensuel)})
                Object.assign(object['inputs'], {'nombre_diagnostic': parseInt(diagnostic)})
                Object.assign(object['inputs'], {'nombre_page_copie': parseInt(value)})
                object.departementid = parseInt(departement)
            }

            dispatch(setSimulateurObject(object));

        } else {

            // process child simu

        }
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>

                <TextfieldRemarques handleChange={handleChangeRemarque}/>

                <p style={styles.cardSubTitle}>
                (Acte tarifé au titre du Tableau 5, n° 70 1°). La provision sur frais calculée ne comprend aucune fiscalité. Si l’enregistrement du bail est requis, un droit fixe d’enregistrement à 25 € est à percevoir.
                </p>

                {props?.isParent === true && props.departements !== "" ?
                    <div style={styles.cardRow}>
                        <div style={styles.cardElemVerticalyCenter}>
                            Département :
                        </div>

                        <SelectDepartement items={props.departements} nameField={"name"} defaultValue={currUserDep} optionValue={"id"}
                                  handleChange={handleChange} setter={setDepartement}/>
                    </div>
                    :
                    <></>
                }

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Quel est le montant du loyer mensuel (hors charges)
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setMontant}
                    />
                </div>


                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Combien de diagnostics immobiliers sont annexés ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Nombre de diagnostics"}
                        setter={setDiagnostic}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Quel est le nombre de page(s) de la copie exécutoire ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Nombre de pages"}
                        setter={setPage}
                    />
                </div>
            </div>
        </div>
    )
}

export default Simulateur_A1_29;
